import { get, post, _delete, put } from './axios'
const baseUrl = 'ba-base-info'
export default class HomeApi {
  /**
   * 获取轮播图
   */
  static async getContent(programType, contentType) {
    return get(`${baseUrl}/selectById`, { programType, contentType })
  }

  /**
   * 添加新的内容
   */
  static async insertContent(baBaseInfo) {
    return post(`${baseUrl}/insertContent`, baBaseInfo)
  }

  /**
   * 删除内容
   */
  static async deleteById(id) {
    return _delete(`${baseUrl}/deleteById`, { id })
  }

  /**
   * 更新内容
   */
  static async updateContent(baBaseInfo) {
    return put(`${baseUrl}/updateContent`, baBaseInfo)
  }

  /**
   * 分页新闻内容
   */
  static async getNewsPage(pagenum, size, contentType) {
    return get(`${baseUrl}/getNewsPage`, {
      pagenum,
      size,
      contentType
    })
  }

  /**
   * 搜索前五条新闻
   */
  static async selectTopFiveNew() {
    return get(`${baseUrl}/selectTopFiveNew`)
  }

  /**
   * 获取seo列表
   */
  static async getSeo(url) {
    return get('ow-seo/getSeo', {
      url
    })
  }

  /**
   * 更新seo
   * @param owseo
   * @returns {AxiosPromise<any>}
   */
  static async updateSeo(owseo) {
    return put('ow-seo/updateSeo', owseo)
  }

  /**
   * 新增新闻
   * @param wxMessage
   * @returns {AxiosPromise<any>}
   */
  static async addNew(wxMessage) {
    return post('/wx-messages/addNew', wxMessage)
  }


  /**
   * 查询所有新闻
   * @returns {AxiosPromise<any>}
   */
  static async getAllWxNew() {
    return get('/wx-messages/getAllWxNew')
  }
}
